export class POSClosedDay {
  id: number | 0;
  hotel_id: number | 0;
  outlet_id: number | 0;
  working_date: Date;
  open_date: Date;
  open_by: number | null;
  closed_date: Date;
  closed_by: number | 0;
  closing_invoice_id: number | 0;
  closing_invoice_number: string | "";
  last_modified: Date | null;
  last_modified_by: number | null;
  created: Date | null;
  created_by: number | null;
}
